import { AfterViewInit, Component, inject } from "@angular/core";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { UserInfo } from "@models/user";
import { ContractDialogComponent } from "@shared/modals/contract-dialog/contract-dialog.component";
import { switchMap, takeUntil } from "rxjs";
import { AppLayoutComponent } from "../../../../shared/components/app-layout/app-layout.component";
import { CardManageEventComponent } from "../../../../shared/components/cards/card-manage-event/card-manage-event.component";
import { PageHeaderComponent } from "../../../../shared/components/page-header/page-header.component";
import { AuthService } from "../../../services/auth.service";
import { UserManagementService } from "../../../services/user-management.service";
import { EventFormComponent } from "../event-form/event-form.component";
import { EnableProducerDialogComponent } from "./enable-producer-dialog/enable-producer-dialog.component";

@Component({
  selector: "app-create-event-container",
  imports: [
    CardManageEventComponent,
    AppLayoutComponent,
    MatDialogModule,
    EventFormComponent,
    PageHeaderComponent,
  ],
  templateUrl: "./create-event-container.component.html",
  styleUrl: "./create-event-container.component.scss",
})
export class CreateEventContainerComponent implements AfterViewInit {
  private readonly _authService = inject(AuthService);
  private readonly _userService = inject(UserManagementService);
  private readonly _modalService = inject(MatDialog);
  private readonly _router = inject(Router);

  ngAfterViewInit(): void {
    this.checkForRoles();
  }

  checkForRoles() {
    const userInfo = this._authService.getLocalStorageUserInfo();

    if (userInfo && !userInfo?.roles.includes("organizer")) {
      this.handleEnableProducerDialog(userInfo);
    }
  }

  openContract() {
    this._modalService.open(ContractDialogComponent, {
      width: "900px",
      maxWidth: "95vw",
    });
  }

  private handleEnableProducerDialog(userInfo: UserInfo) {
    const dialogRef = this._modalService.open(EnableProducerDialogComponent, {
      disableClose: true,
      data: {
        userData: userInfo,
      },
      width: "440px",
      maxHeight: "600px",
    });

    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        this._router.navigateByUrl("/");
      }
    });

    dialogRef.componentInstance.openContractDialogClick
      .pipe(takeUntil(dialogRef.afterClosed()))
      .subscribe(() => this.openContract());

    dialogRef.componentInstance.submitEnableProducerForm
      .pipe(
        takeUntil(dialogRef.afterClosed()),
        switchMap((payload) => this._userService.becomeProducer(payload)),
      )
      .subscribe(() => {
        dialogRef.close(true);
      });
  }
}
